module.exports = __webpack_public_path__ + "img/logout-icon.27ae74c5.png";